import { useState } from "react"

export type ToggleValue = string | number

export const useToggle = (data: ToggleValue[] | (() => ToggleValue[])) => {
  const [selectedType, setSelectedType] = useState<ToggleValue[]>(typeof data === "function" ? data() : data)

  const handleToggleSelection = (
    isOnlySelection: boolean,
    value: ToggleValue,
    onChange: (e: ToggleValue[]) => void,
  ) => {
    let updated: ToggleValue[]

    if (isOnlySelection) {
      updated = [value]
    } else {
      updated = selectedType.includes(value) ? selectedType.filter((item) => item !== value) : [...selectedType, value]
    }

    setSelectedType(updated)
    onChange(updated)
  }

  return {
    selectedType,
    setSelectedType,
    handleToggleSelection,
  }
}
